const html = document.querySelector('html');

export default {
    data() {
        return {
            modal: {
                show: false,
            },
        };
    },

    methods: {
        open() {
            this.modal.show = true;
            html.classList.add('scroll-lock');
        },

        close() {
            this.modal.show = false;
            html.classList.remove('scroll-lock');
        },
    },
};
